import { MedicalOrderScannType } from './medical-order-scann-type';
export class MedicalOrderScann {
  public Id: number;
  public Image64: string;
  public ImageName: string;
  public MedicalOrderId: number;
  public MedicalOrderScannTypeId: number;
  public deleting: boolean;
  public Index: number;
}
